import React, { useRef } from 'react';
import { ImageMedia, MotionContent, Page, SectionTitle, } from '../components/imports';
import { services } from '../data/data';
import { twMerge } from 'tailwind-merge';
import useServices from '../hooks/useServices';
import { projects } from '../data/worklog';
import useLink from '../hooks/useLink';
import { NavLink } from 'react-router-dom';
import { img_earth } from '../assets';



export const capData = [
  { color: "#FFF" },
  { color: "#D1F8AB" },
  { color: "#EB7F45" },
  { color: "#74AFD9" }
]

const Capabilities = ({ prev }) => {

  const s = {
    title: "L'expertise que nous vendons",
    descr: "Au delà de créer du contenu, nous sculptons des identités visuelles cohérentes et des expériences de marque mémorables. Grâce à une combinaison unique de stratégie, design et innovation 3D, nous transformons les idées en actifs de marque puissants, capables de captiver et de convertir."
  }

  const { lawwdMap } = useRef(null);

  return (
    <Page className={"lg:pb-24"}>

      <div className='absolute inset-x-0 top-0 z-[1] h-[30vh] mix-blend-darken max-h-[500px] bg-gradient-to-b from-dark' />
      <MotionContent imgRef={lawwdMap} height={"!h-[50vh] lg:!h-[80vh]"} className={"relative bg-dark"} translateRange={["0%", "-10%"]} >
        <ImageMedia src={img_earth} loading={"eager"} className="origin-bottom object-bottom !full !overflow-visible " />
      </MotionContent>


      <SectionTitle {...s} className="resp text-balance" titleCSS={"lg:!text-7xl"} />


      <div className={twMerge('grid relative w-full resp !px-0 pl-0')}>
        {/* EXPERTISE TEXT */}
        <div className={`mt-4 lg:mt-16 relative flex flex-col ${prev && "grid grid-cols-2 gap-16"} paddingX text-blakk= mb-16`}>
          {services.map((item, index) => {
            const i = `0${index + 1}`
            return <ExpertiseItem key={i} index={index} {...item} i={i} prev={prev} />
          })}
        </div>

      </div>
    </Page>
  )
}

const ExpertiseItem = ({ prev, i, index, color, keyProjects, ...props }) => {

  const { seeServices } = useServices();
  // const openCondition = currentId === index;
  // const { ease, duration } = animA()
  const prLink = useLink();

  return (
    <div
      // onPointerEnter={() => seeServices(index)}
      // initial={{ opacity: .1, translateY: 50 }}
      // whileInView={{ opacity: 1, translateY: 0 }}
      // transition={{ ease, duration }}
      onClick={() => seeServices(index)}
      className={twMerge('relative flex flex-col items-start justify-start w-full py-16',)}>

      <div className={twMerge('flex flex-col lg:flex-row w-full items-start justify-start lg:max-h-[90svh]= ', !prev && index > 0 && "border-t border-gray-500/20", prev && "border-t border1")}>
        <div className='relative w-full flex flex-col items-start'>
          <div className={twMerge(`w-full relative z-[2]= flex flex-col *:w-fit mt-8`)}>
            <h4 style={{ fontWeight: 500 }} className='font-mono tracking-tighter dim muted'>{i}<span className='muted dim'>/0{services.length}</span></h4>
            <div className='inline max-w-[40ch] text-balance justify-center items-center space-x-2'>
              <h2 style={{ fontWeight: 500 }} className='inline text-balance uppercase w-full max-sm:leading-tight max-sm:maxW'>{props.label}</h2>
              <span className='inline'><i className={`${props.icon} inline-flex size-10 -translate-y-2 lg:-translate-y-3 bg-gray-500/10 hover:bg-gray-500/15 quick rounded-full center ri-xl text-red-500`} /></span>
            </div>
            <h4 className='mt-8 lg:landscape:max-w-[40ch] font-light noaction muted dim text-pretty'>{props.descr}</h4>
          </div>

          <div id="ServiceCategories" className='relative flex flex-col lg:gap-2 my-4 lg: mt-8 w-full'>
            {props.categories.map((category, i) => {
              const content = Array.from(category.contains)
              return (
                <div key={category + i} className='flex justify-start border-b last:border-b-0 rounded-bl-lg border1= border-gray-500/20 py-3 lg:pb-2'>
                  <h4 className='w-full max-w-[20ch] unmuted font-normal capitalize'>
                    <span className='text-red-500'>+</span>&nbsp;{category.label}
                  </h4>
                  <div className='inline-flex lg: max-w-[45ch] text-pretty items-end max-sm:my-2= relative w-full flex-wrap'>
                    {content.map((item, j) => {
                      return (
                        <h4 key={item} className='inline flex-wrap !font-base *:capitalize *:inline dim muted'>
                          <span className='muted hover:unmute quicker cursor-default lg:hover:rounded-lg hover:bg-white/10'>{item}</span>
                          <span className='muted'>{j < content.length - 1 && <>,&nbsp;</>}</span>
                        </h4>
                      )
                    })}
                  </div>
                </div>
              )
            })}
          </div>
        </div>

        <div className='mt-8 flex flex-col items-start w-full h-full'>
          <div id="keyProjectsMOB" className='MOB= flex flex-col flex-[1] w-full lg:landscape:pl-[6em] group mt-2 lg:mt-6'>
            <h4 id="buttonUnderline" className='flex relative items-center py-1 border-b border1 mix-blend-difference text-white dim w-fit'>
              Projets à découvrir
              <i className='ri-arrow-down-line -rotate-45 flex center aspect-square rounded-full size-8' />
            </h4>

            <div className='flex flex-row lg:flex-col gap-4 lg:gap-8 mt-2 w-full h-full3'>
              {keyProjects.map((project, i) => {
                const thisRef = projects.find(pr => pr.client === project.clientRef)
                const refImage = thisRef.metadata?.thumbnail;

                return (
                  <NavLink key={`KeyProject_0` + i} to={`/work/${prLink(project.clientRef)}`} target="_blank" className={"w-full group muted hover:unmute quick"}>
                    <div className='flex flex-col gap-4 relative items-start justify-end aspect-square= max-w-56+ w-full =max-h-72 overflow-y-clip origin-top-left hover:scale-[102%] quicker rounded'>
                      <div className='relative flex center full overflow-clip aspect-video'>
                        {/* <DefaultContent title={"DefaultContent_"+i} /> */}
                        <ImageMedia bypass src={require(`../projects/${prLink(project.clientRef)}/${refImage}`)} className="object-center" />
                      </div>
                      <div className='block *:inline lg:space-x-1 flex-col= capitalize leading-tight'>
                        <h4>{project.clientRef}</h4>
                        {thisRef?.metadata.year && <h5 className='dim muted'>&nbsp;— {thisRef?.metadata.year}</h5>}
                      </div>
                    </div>
                  </NavLink>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export default Capabilities